import moment from 'moment';

const sortByStartTime = makeDescSorting('startTime');
const sortByCreatedTime = makeDescSorting('createdAt');

export function formatAppointmentList(list) {
  const timeFormattedList = formatAppointmentStartTime(list);
  const marked = markOverdueAppointmentList(timeFormattedList);
  return sortAppointmentList(marked);
}

export function sortAppointmentList(list) {
  return list
    .sort(sortByCreatedTime)
    .sort(sortByStartTime)
    .sort(sortByPinnedTime);
}

export function markOverdueAppointmentList(list) {
  return list.map(markOverdueAppointment);
}

function convertToLocalUTCTime(time) {
  return moment
    .utc(time)
    .subtract(moment().utcOffset(), 'm')
    .toISOString();
}

export function transformTimeAdapter(item) {
  if (item._timeFormatted) {
    return item;
  }
  const { startTime } = item;

  return {
    ...item,
    _timeFormatted: true,
    startTime,
  };
}

export function formatAppointmentStartTime(list) {
  return list.map(transformTimeAdapter);
}

function makeTS(date) {
  return new Date(date).getTime();
}

function makeDescSorting(sortBy) {
  return (current, next) => {
    const currentTS = makeTS(current[sortBy]);
    const nextTS = makeTS(next[sortBy]);

    if (currentTS < nextTS) {
      return -1;
    }

    if (currentTS > nextTS) {
      return 1;
    }

    return 0;
  };
}

function sortByPinnedTime(current, next) {
  const currentTS = makeTS(current.pinnedAt);
  const nextTS = makeTS(next.pinnedAt);

  if (currentTS > nextTS) {
    return -1;
  }

  if (currentTS < nextTS) {
    return 1;
  }

  return 0;
}

export function markOverdueAppointment(item) {
  const timeNow = moment();

  const isOverdue = moment(item.startTime)
    .add(15, 'm')
    .isBefore(timeNow);

  return { ...item, isOverdue };
}

export function toggleHighlightStatus(list, matchId, isnew) {
  const result = [...list];
  const index = list.findIndex(({ id }) => id === matchId);
  if (index >= 0) {
    const item = list[index];
    result[index] = { ...item, isnew };
  }

  return result;
}

export function findAndReplace(list, item, addIfEmpty = false) {
  const result = [...list];

  const index = list.findIndex(({ id }) => id === item.id);

  if (item.status && item.status.displayableOnDashboard === false) {
    result.splice(index, 1);
  } else if (index >= 0) {
    result[index] = item;
  } else if (addIfEmpty) {
    result.push(item);
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/utils/dashboard/handleOverdueAppointments.js